import { useState, type FormEvent } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Boton } from "../components/Boton";
import { Campo, Input } from "../components/Formulario";
import { ErrorApi } from "../lib/apiClient";
import { useAuthSuperadmin } from "./SuperadminAuthContext";

export function SuperadminLoginPage() {
  const { superadmin, cargandoInicial, iniciarSesion } = useAuthSuperadmin();
  const navegar = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  if (!cargandoInicial && superadmin) {
    return <Navigate to="/superadmin" replace />;
  }

  async function manejarEnvio(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setEnviando(true);
    try {
      await iniciarSesion(email, password);
      navegar("/superadmin", { replace: true });
    } catch (err) {
      setError(
        err instanceof ErrorApi
          ? err.message
          : "No se pudo iniciar sesión. Intentá nuevamente.",
      );
    } finally {
      setEnviando(false);
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-950 px-4">
      <div className="w-full max-w-sm">
        <div className="mb-8 text-center">
          <div className="mx-auto mb-3 flex h-10 w-10 items-center justify-center rounded-lg bg-white text-lg font-semibold text-slate-900">
            J
          </div>
          <h1 className="text-lg font-semibold text-white">
            Plataforma JVD
          </h1>
          <p className="mt-1 text-sm text-slate-400">
            Acceso exclusivo de administración de plataforma
          </p>
        </div>
        <form
          onSubmit={manejarEnvio}
          className="rounded-xl border border-slate-800 bg-slate-900 p-6 shadow-sm"
        >
          <div className="space-y-4">
            <Campo etiqueta="Email" obligatorio>
              <Input
                type="email"
                autoComplete="username"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="nombre@plataforma.com"
              />
            </Campo>
            <Campo etiqueta="Contraseña" obligatorio>
              <Input
                type="password"
                autoComplete="current-password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
              />
            </Campo>
          </div>
          {error && (
            <div className="mt-4 rounded-lg bg-red-950 px-3 py-2 text-sm font-medium text-red-300">
              {error}
            </div>
          )}
          <Boton type="submit" cargando={enviando} className="mt-5 w-full">
            Ingresar
          </Boton>
        </form>
      </div>
    </div>
  );
}
